"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVerifyReqTool = createVerifyReqTool;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const dist_2 = require("../../../app/dist");
const dist_3 = require("../../../core/dist");
const sampling_1 = require("../sampling");
function msg(role, text) {
    return { role, content: { type: 'text', text } };
}
/**
 * loom_verify_req — verify a thread's plan against its locked req.
 *
 * Two layers: a pure deterministic scope-coverage check (always), plus an AI
 * semantic pass via sampling that catches violations phrased differently than
 * the requirement text. Sampling works in the VS Code extension; in a Claude
 * Code CLI session it is blocked (MethodNotFound) — the structural findings are
 * returned and the agent is expected to judge the semantic part itself.
 */
function createVerifyReqTool(server) {
    return {
        toolDef: {
            name: 'loom_verify_req',
            description: "Verify a thread's plan against its locked req: a deterministic scope-coverage check (uncovered Included, Excluded citations, dangling citations) plus, where sampling is available, an AI semantic pass flagging steps that violate an Excluded item / Constraint or advance an Included item without citing it — even when phrased differently. In a Claude Code CLI session sampling is blocked; the structural findings are returned and the agent should judge the semantic part itself.",
            inputSchema: {
                type: 'object',
                properties: {
                    weave_slug: { type: 'string', description: 'Weave folder slug' },
                    thread_ulid: { type: 'string', description: 'Stable th_ ULID of the thread' },
                },
                required: ['weave_slug', 'thread_ulid'],
            },
        },
        handle: async (root, args) => {
            const weaveSlug = args['weave_slug'];
            const threadUlid = args['thread_ulid'];
            const loomRoot = (0, dist_1.getActiveLoomRoot)(root);
            // Reference the thread by its stable ULID → resolve to the folder slug (the Thread entity's id).
            const { threadSlug } = await (0, dist_2.resolveThreadFolder)(weaveSlug, threadUlid, { getActiveLoomRoot: () => loomRoot, loadDoc: dist_1.loadDoc, fs });
            const index = await (0, dist_1.buildLinkIndex)(loomRoot);
            const weave = await (0, dist_1.loadWeave)(loomRoot, weaveSlug, index);
            const thread = weave?.threads.find((t) => t.id === threadSlug);
            if (!thread)
                throw new Error(`Thread not found: ${weaveSlug}/${threadSlug}`);
            if (!thread.req || thread.req.status !== 'locked') {
                return wrap({ weaveSlug, threadUlid, ok: false, reason: 'thread has no locked req to verify against' });
            }
            const parsed = (0, dist_3.parseReq)(thread.req.content ?? '');
            const steps = thread.plans.flatMap((p) => (p.steps ?? []));
            // Deterministic structural coverage (works everywhere).
            const structural = (0, dist_3.checkReqCoverage)(parsed, steps);
            // Semantic backstop (sampling — extension only; blocked in CLI).
            let semantic = null;
            let semanticError = null;
            try {
                const planText = steps
                    .map(s => `- step ${s.order} [cites: ${(s.satisfies ?? []).join(', ') || 'none'}] ${s.description}`)
                    .join('\n');
                const out = await (0, sampling_1.requestSampling)(server, [msg('user', [
                        'Locked requirements (the authoritative spec):',
                        thread.req.content ?? '',
                        '',
                        'Plan steps (with the requirement ids each cites):',
                        planText,
                        '',
                        'Judge SCOPE FAITHFULNESS only — not code correctness. Flag:',
                        '- any step that implements an ❌ Excluded item or breaks a ⛓ Constraint, even if worded differently;',
                        '- any step that clearly advances a ✅ Included item without citing its id.',
                        'Return ONLY JSON: {"violations":[{"stepOrder":1,"requirement":"EX1","why":"..."}],"uncited":[{"stepOrder":1,"requirement":"IN1"}]} — empty arrays if none.',
                    ].join('\n'))], 'You are a Loom requirements verifier. Judge only whether the plan honours the include/exclude/constraints spec. Be precise and conservative; do not invent violations.');
                try {
                    const m = out.match(/\{[\s\S]*\}/);
                    semantic = m ? JSON.parse(m[0]) : { raw: out };
                }
                catch {
                    semantic = { raw: out };
                }
            }
            catch (e) {
                semanticError = e instanceof Error ? e.message : String(e);
            }
            return wrap({ weaveSlug, threadUlid, structural, semantic, semanticError });
        },
    };
}
function wrap(payload) {
    return { content: [{ type: 'text', text: JSON.stringify(payload) }] };
}
